import React, { useEffect, useRef } from 'react';
import './App.css';
import Editor from 'react-simple-code-editor';
import { highlight, languages } from 'prismjs/components/prism-core';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/themes/prism.css'; //Example style, you can use another
import { Stack, Button, TextField, InputAdornment, Paper, Grid, CircularProgress } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import { styled } from '@mui/material/styles';
import mixpanel from 'mixpanel-browser';

mixpanel.init('9ee880f876f4b81404e331b2c0c79a98', {debug: false}); 

function App() {
  const [code, setCode] = React.useState('');
  const [jsonError, setJsonError] = React.useState(false)
  const [timer, setTimer] = React.useState(null)
  const chatFieldRef = useRef()
  const _idFieldRef = useRef()
  const [messages, setMessages] = React.useState([])
  const [chatLoading, setChatLoading] = React.useState(false)

  useEffect(() => {
    mixpanel.track('visited');
  })

  const codeDidChange = (newCode) => {
    setCode(newCode)

    try {
      var obj = JSON.parse(newCode);
      setJsonError(false)

      if (timer) {
        clearTimeout(timer)
      }
      setTimer(setTimeout(update.bind(null, newCode), 500))
    } catch {
      setJsonError(true)
    }
  }

  const getWidget = () => {
    const _id = _idFieldRef.current.value

    var headers = new Headers();

    var functionKey = 'MkGV6bdjg2ZahCEWDzO-F_HFNF6ZtsrH-G-XR74USZatAzFuVKJa1w==';
    headers.append('x-functions-key', functionKey)

    var requestOptions = {
      method: 'GET',
      headers: headers,
      redirect: 'follow'
    };
    
    fetch("https://scrimage.azurewebsites.net/api/getWidget?_id="+_id, requestOptions)
      .then(response => response.text())
      .then(result => codeDidChange(result))
      .catch(error => {});
  }

  const update = (newCode) => {
    var _id = _idFieldRef.current.value
    _id = _id.trim() === "" ? null : _id

    var obj = null
    try {
      var obj = JSON.parse(newCode);
    } catch { }

    var myHeaders = new Headers();

    var functionKey = 'GrXoDaD4AlvipCqLNPiA4uvsZZjJCevjbchiqRkGmy8AAzFuTHC0zg==';
    myHeaders.append('x-functions-key', functionKey)
    myHeaders.append("Content-Type", "application/json");

    var body = {}

    if (obj) {
      body.jsonContent = obj
    }
    if (_id) {
      body._id = _id
    }

    var raw = null
    try {
      var raw = JSON.stringify(body);
    } catch { }

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      redirect: 'follow'
    };

    if (raw) {
      requestOptions.body = raw
    }

    fetch("https://scrimage.azurewebsites.net/api/createUpdateWidget", requestOptions)
      .then(response => response.json())
      .then(response => updateIdField(response))
      .catch(error => {});
  }

  const updateIdField = (res) => {
    _idFieldRef.current.value = res._id
  }

  const chat = () => {
    const message = chatFieldRef.current.value
    if (message && message.length > 0) {
      setMessages(messages => [...messages, message])
      setChatLoading(true)

      chatFieldRef.current.value = ''

      var myHeaders = new Headers();

      var functionKey = 'SJswkljt0UBfkQa7mwLJu7ojzjgR1a8TJ5g_8VVR1pS6AzFuRPcFeQ==';
      myHeaders.append('x-functions-key', functionKey)
      myHeaders.append("Content-Type", "application/json");

      var obj = {
        "instruction": message,
      }
      if (code && code.length > 0) {
        obj["jsonContent"] = code
      }

      var raw = JSON.stringify(obj);

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      };

      fetch("https://scrimage.azurewebsites.net/api/chat", requestOptions)
        .then(response => response.json())
        .then(response => {
          updateCodeFromChat(response)
        })
        .catch(error => {});
    }
  }

  const updateCodeFromChat = (choices) => {
    const newCode = choices[0].text

    const jsonBeginning = newCode.indexOf("{")
    const jsonEnd = newCode.lastIndexOf("}")
    const cleanedCode = newCode.substring(jsonBeginning, jsonEnd + 1).trim()

    codeDidChange(cleanedCode)
    setChatLoading(false)
  }

  const textfieldOnKeyPress = (event) => {
    if (event.keyCode == 13) {
      chat()
    }
  }

  const Root = styled('div')(({ theme }) => ({
    width: '100%',
    ...theme.typography.body2,
    '& > :not(style) + :not(style)': {
      marginTop: theme.spacing(2),
    },
  }));

  return (
    <>
    <Stack direction="row" justifyContent="space-around" spacing={5} style={{ marginTop: 30 }}>
      <Stack direction="column" style={{
        width: "55%",
      }}>
        <Editor
          value={code}
          onValueChange={code => codeDidChange(code)}
          highlight={code => highlight(code, languages.js)}
          padding={10}
          style={{
            fontFamily: '"Fira code", "Fira Mono", monospace',
            fontSize: 12,
            background: '#ecf0f1',
          }}
        />
        {jsonError ?
          <p>error</p> : <p></p>
        }
        <Stack direction='row' style={{ width: '100%' }}>
          <TextField
            style={{width: '50%'}}
            inputRef={_idFieldRef}
            id="outlined-basic"
            placeholder='_id'
            variant="outlined"
          />
          <Button style={{ marginLeft: '20px', marginRight: '20px' }} onClick={getWidget.bind(this)} variant="contained">Fetch</Button>
          <Button onClick={update.bind(this, code)} variant="contained">Create / Update</Button>
        </Stack>
      </Stack>
      <Stack direction="column" style={{
        width: "35%"
      }} spacing={4}>
        <Root>
          <Stack direction="column" spacing={1}>
            {messages.map((item, index) => {
              return (
                <Paper key={index} style={{ padding: '15px' }} variant="outlined">
                  <Stack
                    direction={'row'}
                    justifyContent="space-between"
                  >
                    <div style={{ width: '95%', display: 'flex', justifyContent: 'flex-start' }}>
                      {item}
                    </div>
                    <div style={{ width: '5%', display: 'flex', justifyContent: 'flex-end' }}>
                      {index == messages.length - 1 && chatLoading ?
                        <CircularProgress size={14} /> : <></>}
                    </div>
                  </Stack>
                </Paper>
              )
            })}
          </Stack>
        </Root>
        <TextField
          inputRef={chatFieldRef}
          id="outlined-basic"
          label="chat"
          variant="outlined"
          onKeyDown={textfieldOnKeyPress}
          InputProps={{
            endAdornment: (<InputAdornment><Button onClick={chat.bind(this)}><SendIcon /></Button></InputAdornment>)
          }} />
      </Stack>
    </Stack>
    {/* <div style={{margin: '30px' }}>
      <br/>
      <h2>How To:</h2>
      <Paper variant='outlined' style={ {padding: '20px'}}>
        * asdfd
      </Paper>
    </div> */}
    
    </>
  );
}

export default App;
